/* NewEden2.0 — animations.js
   Reveal-on-scroll using IntersectionObserver. Honours prefers-reduced-motion.
   Add [data-reveal] (optionally data-reveal-delay="N") to any element. */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var animationsOff = document.body && document.body.classList.contains('animations-off');
  var els = document.querySelectorAll('[data-reveal], .reveal');

  if (reduce || animationsOff || !('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('is-revealed'); });
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var delay = parseInt(el.getAttribute('data-reveal-delay') || '0', 10);
      if (delay) el.style.transitionDelay = delay + 'ms';
      el.classList.add('is-revealed');
      io.unobserve(el);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });

  els.forEach(function (el) { io.observe(el); });

  // Re-scan when sections are re-rendered in the theme editor
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-reveal], .reveal').forEach(function (el) {
      el.classList.remove('is-revealed');
      io.observe(el);
    });
  });
})();
